import React, { useState, useEffect } from 'react';
import { useOrders, searchByText, setOrderSearch, cancelTextSearch} from '../../context/orders/OrdersState';
import Departments from './Departments';
import { isMobile } from 'react-device-detect';

const ProductsFilter = () => {
    const [ordersState, ordersDispatch] = useOrders();
    const {currentOrder, orderSearchText} = ordersState;

    const [showDepartments, setShowDepartments] = useState(false);

    useEffect(() => {
        // This runs on mount
        setOrderSearch(ordersDispatch, '');
    
        return () => {
            // This runs on unmount (when leaving)
            // a search still waiting would otherwise land on the next screen
            cancelTextSearch();
            setOrderSearch(ordersDispatch, '');
        };
    }, []);

    const onChange = e => {
        setOrderSearch(ordersDispatch, e.target.value)
        searchByText(ordersDispatch, currentOrder.fields.id, e.target.value);    
    }

    const toggleDepartments = () => {
        setShowDepartments(!showDepartments);
    }

    return (
        <div className='search'>
            {showDepartments && <Departments closeMenu={toggleDepartments}/>}
            {isMobile && 
              <button class="burger-btn" onClick={toggleDepartments}>
                <i class="fas fa-bars"></i>
              </button>}
            <div className="search_wrapper">
                <div className='searchNameId'>
                    <i className="fas fa-search"></i>
                    <input autoFocus={true} className='nameIdInput' type="text" value={orderSearchText} placeholder="הקלידו שם מוצר / קטגוריה / ברקוד"  onChange={onChange} />
                </div>
            </div>
        </div>
    )
}

export default ProductsFilter
